import styles from './styles.module.scss';

const FooterNavHeader = ({ className = '', text }) => (
    <div className={`${styles.footerListTitleItem} ${styles.footerListItem} ${className}`}>{text}</div>
);

export default FooterNavHeader;
